import React, { createContext, useState, useContext, ReactNode } from 'react';

interface SearchBbox {
  bbox: number[];
  pageNum: number;
  id: number;
}

interface SearchResult {
  pageNum: number;
  bbox: number[];
}

interface SearchBboxContextType {
  searchBboxes: SearchBbox[] | undefined;
  setSearchBboxes: React.Dispatch<React.SetStateAction<SearchBbox[] | undefined>>;
  searchResults: SearchResult[] | undefined;
  setSearchResults: React.Dispatch<React.SetStateAction<SearchResult[] | undefined>>;
  searchQuery: string;
  setSearchQuery: React.Dispatch<React.SetStateAction<string>>;
  highlightColor: string;
  setHighlightColor: (color: string) => void;
}

export const SearchBboxContext = createContext<SearchBboxContextType>({
  searchBboxes: undefined,
  setSearchBboxes: () => {},
  searchResults: undefined,
  setSearchResults: () => {},
  searchQuery: '',
  setSearchQuery: () => {},
  highlightColor: 'yellow',
  setHighlightColor: () => {},
});

export const SearchBboxProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [searchBboxes, setSearchBboxes] = useState<SearchBbox[] | undefined>(undefined);
  const [searchResults, setSearchResults] = useState<SearchResult[] | undefined>(undefined);
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [highlightColor, setHighlightColor] = useState('yellow');

  return (
    <SearchBboxContext.Provider value={{ 
        searchBboxes, setSearchBboxes, 
        searchResults, setSearchResults,
        searchQuery, setSearchQuery,
        highlightColor, setHighlightColor,
    }}>
      {children}
    </SearchBboxContext.Provider>
  );
};

export const useSearchBbox = () => {
  const context = useContext(SearchBboxContext);
  if (context === undefined) {
    throw new Error('useSearchBbox must be used within a SearchBboxProvider');
  }
  return context;
};